export const categories = [
  {
    slug: 'qiweng-xianchang',
    name: '奇闻现场',
    icon: 'ri-flashlight-line',
    desc: '街头巷尾突然发生的怪事，目击者口中的第一现场。',
    count: 128,
    tone: 'primary',
  },
  {
    slug: 'qipa-shijian',
    name: '奇葩事件',
    icon: 'ri-emotion-laugh-line',
    desc: '让人哭笑不得的迷惑操作，看完只想说一句「这也行」。',
    count: 96,
    tone: 'accent',
  },
  {
    slug: 'liqi-anjian',
    name: '离奇案件',
    icon: 'ri-file-search-line',
    desc: '悬而未决的旧案与新案，线索零碎却处处透着反常。',
    count: 74,
    tone: 'secondary',
  },
  {
    slug: 'dushi-guaitan',
    name: '都市怪谈',
    icon: 'ri-moon-foggy-line',
    desc: '流传在深夜地铁与老楼之间的怪谈，真伪各半。',
    count: 63,
    tone: 'primary',
  },
  {
    slug: 'minjian-chuanshuo',
    name: '民间传说',
    icon: 'ri-book-2-line',
    desc: '乡野口耳相传的老故事，一代代人添油加醋的版本。',
    count: 51,
    tone: 'accent',
  },
  {
    slug: 'mihuo-xingwei',
    name: '迷惑行为',
    icon: 'ri-question-line',
    desc: '看不懂却很上头的行为图鉴，跨国文化的错位瞬间。',
    count: 88,
    tone: 'secondary',
  },
];

export const featuredStories = [
  {
    id: 'a01',
    region: '日本',
    category: '离奇案件',
    title: '便利店店员记住了三千张脸：一桩靠「认脸」破获的连环案',
    excerpt:
      '东京一家深夜便利店的店员，靠着两年间对常客面孔的异常记忆，最终帮警方拼出了一条关键线索。他记的不是名字，而是每个人进店时的走姿。',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20night%20convenience%20store%20glow%20seen%20from%20across%20a%20rainy%20street%2C%20warm%20amber%20light%20spilling%20out%2C%20lone%20silhouette%2C%20editorial%20photography%20with%20grainy%20texture%20and%20deep%20shadows&width=1200&height=800&seq=chigua-feature-01&orientation=landscape',
    date: '2026-08-28',
    readTime: 9,
    views: '4.2万',
    author: '频道编辑组',
    tags: ['东京', '便利店', '线索', '深夜'],
  },
  {
    id: 'a02',
    region: '美国',
    category: '奇葩事件',
    title: '为了不还一本书，他给整条街的图书馆寄了七年明信片',
    excerpt:
      '一本过期未还的旧书，牵出一段横跨七个年头的奇怪通信。馆员们最终决定不追究，而是把那本书单独摆进了一个玻璃柜。',
    cover:
      'https://readdy.ai/api/search-image?query=Vintage%20library%20reading%20room%20with%20tall%20wooden%20shelves%20and%20warm%20afternoon%20sunlight%20through%20arched%20windows%2C%20stack%20of%20old%20postcards%20on%20a%20reading%20desk%2C%20nostalgic%20editorial%20photography&width=1200&height=800&seq=chigua-feature-02&orientation=landscape',
    date: '2026-08-25',
    readTime: 7,
    views: '3.6万',
    author: '频道编辑组',
    tags: ['旧书', '明信片', '图书馆'],
  },
  {
    id: 'a03',
    region: '日本',
    category: '都市怪谈',
    title: '那趟末班车为什么总在同一站多停十秒',
    excerpt:
      '一段被反复讨论的都市怪谈，背后其实是站务记录里一条找不到归属的时刻表批注。追问下去，答案比传说本身更安静。',
    cover:
      'https://readdy.ai/api/search-image?query=Empty%20late%20night%20train%20platform%20in%20Japan%20with%20a%20single%20dim%20lamp%2C%20foggy%20air%2C%20electric%20departure%20board%20glowing%20softly%2C%20cinematic%20muted%20tones%2C%20atmospheric%20and%20eerie&width=1200&height=800&seq=chigua-feature-03&orientation=landscape',
    date: '2026-08-21',
    readTime: 8,
    views: '5.8万',
    author: '夜行观察',
    tags: ['末班车', '时刻表', '怪谈'],
  },
  {
    id: 'a04',
    region: '美国',
    category: '迷惑行为',
    title: '小镇居民集体把自家门牌号倒着挂，只因为一封匿名信',
    excerpt:
      '起初大家以为是谁在恶作剧，后来才发现倒挂的门牌号其实是一套只有本地人才懂的暗号，用来标记谁家的狗会咬人。',
    cover:
      'https://readdy.ai/api/search-image?query=Quiet%20american%20suburban%20street%20with%20wooden%20houses%20and%20upside%20down%20house%20number%20plaques%2C%20autumn%20leaves%2C%20soft%20overcast%20light%2C%20quirky%20editorial%20documentary%20style&width=1200&height=800&seq=chigua-feature-04&orientation=landscape',
    date: '2026-08-18',
    readTime: 6,
    views: '2.9万',
    author: '频道编辑组',
    tags: ['小镇', '暗号', '邻里'],
  },
  {
    id: 'a05',
    region: '日本',
    category: '民间传说',
    title: '山形县的「借碗石」：村里借东西从不写借条',
    excerpt:
      '一块被称作「借碗石」的溪边大石，承载着村里一套口头的信用规则。规则延续了上百年，比任何契约都管用。',
    cover:
      'https://readdy.ai/api/search-image?query=Mossy%20stone%20by%20a%20quiet%20mountain%20stream%20in%20rural%20Japan%2C%20ceramic%20bowls%20placed%20neatly%20on%20the%20rock%2C%20green%20forest%20mist%2C%20soft%20natural%20light%2C%20serene%20documentary%20photography&width=1200&height=800&seq=chigua-feature-05&orientation=landscape',
    date: '2026-08-14',
    readTime: 7,
    views: '2.1万',
    author: '乡野记述',
    tags: ['山形县', '信用', '民俗'],
  },
  {
    id: 'a06',
    region: '美国',
    category: '奇闻现场',
    title: '高速公路旁那间「永远亮着灯」的小屋',
    excerpt:
      '过路人拍了它十七年，从没人见过屋主。直到某个冬天，灯灭了，门口贴出一张手写告示，解释了这一切。',
    cover:
      'https://readdy.ai/api/search-image?query=Small%20isolated%20wooden%20house%20beside%20a%20deserted%20highway%20at%20dusk%20with%20a%20single%20warm%20lit%20window%2C%20wide%20empty%20landscape%2C%20moody%20cinematic%20editorial%20photography&width=1200&height=800&seq=chigua-feature-06&orientation=landscape',
    date: '2026-08-09',
    readTime: 8,
    views: '3.3万',
    author: '频道编辑组',
    tags: ['公路', '灯光', '告示'],
  },
];

export const latestStories = [
  { id: 'l01', category: '都市怪谈', region: '日本', title: '电梯里的第三层按钮，物业说那层楼从来没建过', date: '2026-09-08', views: '1.8万' },
  { id: 'l02', category: '奇葩事件', region: '美国', title: '他把车停进自家院子，结果收到了三十七张罚单', date: '2026-09-06', views: '1.2万' },
  { id: 'l03', category: '离奇案件', region: '日本', title: '消失的便利店收据，成了十年后重启调查的钥匙', date: '2026-09-05', views: '2.4万' },
  { id: 'l04', category: '迷惑行为', region: '美国', title: '邻居报警说有人半夜浇花，警察到场发现是喷头坏了', date: '2026-09-03', views: '9800' },
  { id: 'l05', category: '民间传说', region: '日本', title: '海边小村的「归还日」：捡到东西必须原地放回三天', date: '2026-09-01', views: '1.5万' },
  { id: 'l06', category: '奇闻现场', region: '美国', title: '火车站广播连续一个月念同一个陌生名字', date: '2026-08-30', views: '2.7万' },
  { id: 'l07', category: '离奇案件', region: '美国', title: '一份被退回二十四次的信，最终送到了对的人手里', date: '2026-08-29', views: '1.1万' },
  { id: 'l08', category: '都市怪谈', region: '日本', title: '自动贩卖机深夜自动找零，记录却显示没有任何交易', date: '2026-08-27', views: '1.9万' },
];

export const deepDive = {
  eyebrow: '本期深度观察',
  title: '为什么「无奇不有」的故事，总能在美日两国反复出现？',
  dek:
    '同样的都市传说结构，一边来自高密度社区的集体记忆，一边来自地广人稀处的孤独叙事。把它们放在一起读，会看到两套完全不同的「怪」的生成方式。',
  author: '特约撰稿 · 林岸',
  date: '2026-09-02',
  readTime: 11,
  paragraphs: [
    '在东京，一条怪谈往往诞生于极度拥挤的空间。电梯、末班车、24 小时便利店、共享公寓的走廊——这些地方每天被无数人经过，任何一次反常都会被几十双眼睛同时记住。于是怪谈像涟漪一样扩散：第一手目击者只有三五个，但转述者可以有几百个。',
    '而在美国中西部，故事的土壤恰好相反。一条公路、一间独自亮着灯的小屋、一个只有两百人的小镇，人和人之间的物理距离拉得极远。这里的怪谈更依赖「谁在深夜看到了什么」，目击者往往孤立无援，叙述里因此多出一层说不清的空旷感。',
    '把两种故事并排放在一起，你会发现它们追问的其实是同一件事：当一件无法解释的事情发生时，一群人会选择记住它，还是选择忘掉它？都市怪谈是记住的方式，而公路故事往往是刻意遗忘的结果。',
    '我们整理这些内容时，始终遵守一条原则：不把传闻当成事实，也不因为它是传闻就随便丢弃。每一条收录都会标注大致来源与流传年代，把「发生了什么」和「人们怎么说」分开写清楚。',
    '这也是「美日吃瓜」想做的事——不是为了证明世界有多离奇，而是想知道，面对离奇，人为什么会这样讲述。',
  ],
  pullQuote: '都市怪谈是记住的方式，公路故事往往是刻意遗忘的结果。',
};

export const siteStats = [
  { value: '500+', label: '已收录故事', icon: 'ri-archive-line' },
  { value: '12 年', label: '内容积累跨度', icon: 'ri-history-line' },
  { value: '46 州 / 47 县', label: '覆盖地域', icon: 'ri-map-pin-line' },
  { value: '每天 2 更', label: '更新节奏', icon: 'ri-calendar-check-line' },
];

export const testimonials = [
  {
    name: '阿凉',
    role: '长期读者',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20illustrated%20portrait%20of%20a%20young%20reader%20with%20warm%20paper%20texture%20background%20and%20vermillion%20accents%2C%20minimal%20editorial%20style&width=200&height=200&seq=chigua-avatar-01&orientation=squarish',
    text: '最喜欢它把「到底发生了什么」和「大家是怎么传的」分开写，看完不会觉得被忽悠。',
  },
  {
    name: '小林晚',
    role: '深夜读者',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20illustrated%20portrait%20of%20a%20calm%20night%20owl%20reader%20with%20amber%20and%20cream%20tones%2C%20minimal%20editorial%20style&width=200&height=200&seq=chigua-avatar-02&orientation=squarish',
    text: '每篇结尾的来源说明很加分，至少知道哪些是可靠线索，哪些只是口口相传。',
  },
  {
    name: '周野',
    role: '民俗爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20illustrated%20portrait%20of%20a%20folk%20culture%20enthusiast%20with%20deep%20teal%20and%20paper%20tones%2C%20minimal%20editorial%20style&width=200&height=200&seq=chigua-avatar-03&orientation=squarish',
    text: '民间传说那一栏整理得很仔细，会把不同版本的差异标出来，很少见。',
  },
];

export const faqs = [
  {
    q: '「美日吃瓜」的内容主要来自哪里？',
    a: '内容来自公开的新闻报道、法院公开文书、地方志与民间口述记录，以及读者投稿。每篇收录都会尽量标注来源类型与大致年代，无法核实的部分会明确写成「传闻」。',
  },
  {
    q: '为什么有些故事没有明确结局？',
    a: '很多离奇案件与都市怪谈本身就悬而未决。我们不会为了好看而强行编造结局，而是把已有的线索、争议点和不同说法如实呈现，让读者自己判断。',
  },
  {
    q: '可以投稿自己遇到的奇闻吗？',
    a: '可以。通过页面底部的订阅与投稿表单提交即可，建议写清楚时间、地点和你确认过的部分。刻意编造的内容，编辑组核实后不会收录。',
  },
  {
    q: '为什么把美国与日本的奇闻放在一起？',
    a: '两国社会结构差异很大，同样的「怪事」在两种环境里生成和传播的方式完全不同。对照着读，比单独看某一国的故事更有意思。',
  },
  {
    q: '内容会涉及真实姓名和隐私吗？',
    a: '不会。涉及在世普通人的故事，我们统一使用化名并模糊具体门牌信息；只有公开报道中被官方确认的情形才会保留必要细节。',
  },
  {
    q: '更新频率是怎样的？',
    a: '通常每天更新两篇，周末会集中整理一期「本周吃瓜合集」，把当周讨论度最高的故事重新梳理一遍。',
  },
];

export const navLinks = [
  { id: 'top', label: '首页' },
  { id: 'categories', label: '主题分类' },
  { id: 'featured', label: '热门推荐' },
  { id: 'latest', label: '最新收录' },
  { id: 'deepdive', label: '深度观察' },
  { id: 'faq', label: '常见问题' },
  { id: 'about', label: '关于我们' },
];